import { type UseFormReturn } from 'react-hook-form';
import * as z from 'zod';

import { AuditLightingTypeFormEntrySchema } from '#packages/data-collection/models/audit-lighting-type-form';
import { AttachmentSchema } from '#packages/data-collection/models/common/attachment';

const FormAttachmentSchema = AttachmentSchema.extend({
  file: z.instanceof(File),
});

export const EditAuditFormLightingTypeEntryDataSchema =
  AuditLightingTypeFormEntrySchema.omit({
    attachments: true,
  }).extend({
    attachments: z.array(FormAttachmentSchema).optional(),
  });

export type EditAuditFormLightingTypeEntryData = Omit<
  z.infer<typeof EditAuditFormLightingTypeEntryDataSchema>,
  'quantity' | 'lampWattage' | 'ballastFactor' | 'fixtureWattage'
> & {
  quantity?: string;
  lampWattage?: string;
  ballastFactor?: string;
  fixtureWattage?: string;
};

export type EditAuditFormLightingTypeEntry =
  UseFormReturn<EditAuditFormLightingTypeEntryData>;
